import { useEffect } from 'react'
import classnames from 'classnames'

import CircleLoader from '@components/CircleLoader'
import Checkbox from '@components/Checkbox'
import { selectedSeasonTicketSelector, selectedTicketRatePendingSelector } from 'booking/selectors'
import featureToggles from 'shared/featureToggles'
import useRequestPending from 'shared/hooks/useRequestPending'
import { RateCurrency } from 'shared/price-utilities'

import styles from './styles.module.scss'

const DateRate = ({ ratePending, ticketRates, setAutoRenew, translate: t }) => {
    const { isLoading } = useRequestPending(ratePending)

    const autoRenewHandler = e => {
        setAutoRenew(e.target.checked)
    }

    useEffect(() => {
        if (featureToggles.isRenewSubscriptionAlways) {
            setAutoRenew(true)
        }
    }, [])

    return (
        <div>
            {isLoading ? (
                <CircleLoader className="mx-auto mb-5" />
            ) : (
                ticketRates?.rate && (
                    <>
                        {!featureToggles.isRenewSubscriptionAlways && ticketRates?.rate?.promptAutoRenew && (
                            <Checkbox
                                required
                                className={classnames('mb-6', styles.datePrice)}
                                name="autoRenew"
                                label={t('subscription.purchase.autorenew.label')}
                                onChange={autoRenewHandler}
                            />
                        )}
                        <div className="mb-2">
                            <span className={styles.datePrice}>
                                <T>subscription.purchase.label.full.month.price</T>:
                            </span>{' '}
                            <RateCurrency
                                value={ticketRates?.rate?.recurringAmount}
                                currency={ticketRates?.rate?.currencySymbol}
                            />
                        </div>
                        <span className={styles.datePrice}>
                            <T>subscription.purchase.label.initial.price</T>:
                        </span>{' '}
                        <RateCurrency value={ticketRates?.rate?.amount} currency={ticketRates?.rate?.currencySymbol} />
                        <h5 className="text-uppercase mt-6 mb-4">
                            <T>subscription.purchase.label.billing.rules</T>
                        </h5>
                        <ul className={styles.dateRules}>
                            <li className="mb-2">
                                <T>subscription.purchase.billing.rules.text.1</T>
                            </li>
                            <li>
                                <T>subscription.purchase.billing.rules.text.2</T>
                            </li>
                        </ul>
                    </>
                )
            )}
        </div>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            ratePending: selectedTicketRatePendingSelector,
            ticketRates: selectedSeasonTicketSelector,
        }),
        {}
    )
)(DateRate)
